<template>
  <div class="tab-content">
    <!-- Header -->
    <div class="section-header">
      <div>
        <h3>Definiciones de Atributos</h3>
        <p class="text-muted">Gestione los atributos dinámicos del sistema</p>
      </div>
      <el-button
        type="primary"
        @click="$emit('open-modal')"
      >
        <i class="el-icon-plus"></i> Nuevo Atributo
      </el-button>
    </div>

    <!-- Tabla de definiciones -->
    <el-table
      v-loading="loading"
      :data="definiciones"
      border
      stripe
    >
      <el-table-column
        prop="Codigo"
        label="Código"
        width="80"
      />
      <el-table-column
        prop="Etiqueta"
        label="Etiqueta"
        min-width="200"
      />
      <el-table-column
        prop="Clave"
        label="Clave"
        min-width="150"
      />
      <el-table-column
        prop="Tipo"
        label="Tipo"
        width="120"
      >
        <template #default="{ row }">
          <el-tag :type="getTipoTagType(row.Tipo)">{{ getTipoLabel(row.Tipo) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Opciones"
        width="100"
        align="center"
      >
        <template #default="{ row }">
          <template v-if="row.Tipo === 'select' || row.Tipo === 'multiselect'">
            <el-tag
              v-if="row.AtributoOpcion?.length"
              type="success"
              size="small"
            >
              {{ row.AtributoOpcion.length }}
            </el-tag>
            <el-tag
              v-else
              type="warning"
              size="small"
              >0</el-tag
            >
          </template>
          <span
            v-else
            class="text-muted"
            >-</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="Entidades"
        min-width="200"
      >
        <template #default="{ row }">
          <el-tag
            v-for="rel in row.AtributoEntidadRelacion"
            :key="rel.Codigo"
            size="small"
            class="mr-1"
          >
            {{ rel.Entidad?.Nombre }}
          </el-tag>
          <span
            v-if="!row.AtributoEntidadRelacion?.length"
            class="text-muted"
          >
            Sin asignar
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Acciones"
        width="150"
        fixed="right"
      >
        <template #default="{ row }">
          <el-button
            size="small"
            text
            :icon="Edit"
            @click="$emit('edit', row)"
          />
          <el-popconfirm
            title="¿Está seguro de eliminar este atributo?"
            confirm-button-text="Sí"
            cancel-button-text="No"
            @confirm="$emit('delete', row.Codigo)"
          >
            <template #reference>
              <el-button
                size="small"
                text
                type="danger"
                :icon="Delete"
              />
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import {
  Delete,
  Edit,
} from '@element-plus/icons-vue';

defineProps({
  definiciones: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['open-modal', 'edit', 'delete']);

function getTipoTagType(tipo) {
  const types = {
    string: '',
    number: 'success',
    boolean: 'info',
    date: 'warning',
    select: 'primary',
    multiselect: 'danger',
  };
  return types[tipo] || '';
}

function getTipoLabel(tipo) {
  const labels = {
    string: 'Texto',
    number: 'Número',
    boolean: 'Booleano',
    date: 'Fecha',
    select: 'Select',
    multiselect: 'Multi-Select',
  };
  return labels[tipo] || tipo;
}
</script>

<style scoped>
.tab-content {
  padding: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: 600;
}

.text-muted {
  color: #909399;
  font-size: 14px;
}

.mr-1 {
  margin-right: 4px;
}
</style>
